export default __webpack_public_path__ + "static/media/mohren-loader-weiss.ca007603.gif";